import { Reducer } from 'redux';
import { AdvancedSearchModel, Filter } from 'src/models/AdvanceSearchModel';
import { RESET_ADVANCED_SEARCH, SET_ADVANCED_SEARCH } from 'src/redux/actions/advancedSearchAction';
import { RESET_DATAGRID_STATE } from 'src/redux/actions/datagridActions';
import { getOperatorAndFilters } from 'src/lib/QueryBuilderHelper';

export type AdvancedSearchState = AdvancedSearchModel;

const DEFAULT = {} as AdvancedSearchState;

const getFilter = (filters: Filter[]) => filters.map((filter) => [...filter]);

const advancedSearchReducer: Reducer<AdvancedSearchState> = (state = DEFAULT, action) => {
  switch (action.type) {
    case SET_ADVANCED_SEARCH: {
      const { entity, filters } = action.payload;
      const [operator, advanceSearch] = getOperatorAndFilters(filters);
      return {
        ...state,
        [entity]: {
          [operator]: getFilter(advanceSearch),
        },
      };
    }
    case RESET_ADVANCED_SEARCH: {
      const { entity } = action.payload;
      return {
        ...state,
        [entity]: { and: [['', '', '']] },
      };
    }
    case RESET_DATAGRID_STATE:
      return DEFAULT;
    default:
      return state;
  }
};

export default advancedSearchReducer;
